(() => {
  const formatMoney = (cents) => {
    const currency = window.STOA?.currency || 'CLP';
    const locale = window.STOA?.locale || 'es-CL';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: currency === 'CLP' ? 0 : 2
    }).format((Number(cents) || 0) / 100);
  };

  const escapeHTML = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  class StoaCartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-cart-panel]');
      this.body = this.querySelector('[data-cart-body]');
      this.total = this.querySelector('[data-cart-total]');
      this.empty = this.querySelector('[data-cart-empty]');
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-close]')) this.close();
        const remove = event.target.closest('[data-cart-remove]');
        if (remove) this.changeLine(remove.dataset.key, 0);
      });
      document.addEventListener('stoa:cart:open', () => this.open());
      document.addEventListener('stoa:cart:refresh', () => this.refresh(true));
      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape' && this.hasAttribute('open')) this.close();
      });
    }

    open() {
      this.setAttribute('open', '');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('stoa-cart-open');
      this.refresh(false);
      requestAnimationFrame(() => this.querySelector('[data-cart-close]')?.focus());
    }

    close() {
      this.removeAttribute('open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('stoa-cart-open');
      document.querySelector('[data-cart-trigger]')?.focus();
    }

    async refresh(openAfter = false) {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('No se pudo cargar el carrito.');
        const cart = await response.json();
        this.render(cart);
        if (openAfter) this.open();
      } catch (error) {
        console.warn('STOA cart:', error);
      }
    }

    async changeLine(key, quantity) {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        if (!response.ok) throw new Error('No se pudo actualizar el carrito.');
        const cart = await response.json();
        this.render(cart);
      } catch (error) {
        console.warn('STOA cart:', error);
      }
    }

    render(cart) {
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = cart.item_count;
        node.hidden = cart.item_count === 0;
      });
      if (!this.body) return;
      if (!cart.items.length) {
        this.body.innerHTML = '<div class="stoa-cart-empty"><div><p class="stoa-kicker">Tu carrito está vacío.</p><p>Explora el sistema STOA y elige tu punto de entrada.</p></div></div>';
      } else {
        this.body.innerHTML = cart.items.map((item) => `
          <article class="stoa-cart-item">
            ${item.image ? `<a href="${escapeHTML(item.url)}"><img src="${escapeHTML(item.image)}&width=160" width="80" height="80" loading="lazy" alt="${escapeHTML(item.product_title)}"></a>` : ''}
            <div>
              <a class="stoa-cart-item__title" href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>
              ${item.variant_title ? `<div class="stoa-cart-item__meta">${escapeHTML(item.variant_title)}</div>` : ''}
              <div class="stoa-cart-item__meta">Cantidad: ${item.quantity}</div>
              <strong>${formatMoney(item.final_line_price)}</strong>
            </div>
            <button class="stoa-cart-item__remove" type="button" data-cart-remove data-key="${escapeHTML(item.key)}" aria-label="Eliminar ${escapeHTML(item.product_title)}">Eliminar</button>
          </article>
        `).join('');
      }
      if (this.total) this.total.textContent = formatMoney(cart.total_price);
      this.querySelector('[data-cart-checkout]')?.toggleAttribute('disabled', cart.item_count === 0);
    }
  }

  if (!customElements.get('stoa-cart-drawer')) {
    customElements.define('stoa-cart-drawer', StoaCartDrawer);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cart-trigger]');
    if (!trigger) return;
    const drawer = document.querySelector('stoa-cart-drawer');
    if (!drawer) return;
    event.preventDefault();
    drawer.open();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-stoa-product-form]');
    if (!form || window.STOA?.cartType !== 'drawer') return;
    event.preventDefault();
    const submit = form.querySelector('[data-product-submit]');
    const errorNode = form.querySelector('[data-product-form-error]');
    if (submit) submit.disabled = true;
    if (errorNode) errorNode.textContent = '';
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'No fue posible agregar el producto.');
      document.dispatchEvent(new CustomEvent('stoa:cart:refresh'));
    } catch (error) {
      if (errorNode) errorNode.textContent = error.message;
      else console.warn('STOA add to cart:', error);
    } finally {
      if (submit) submit.disabled = false;
    }
  });
})();
